export default __webpack_public_path__ + "static/media/cnvinbox-origin.1c76481c.png";